import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import PropTypes from "prop-types";
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import SoftBox from 'components/SoftBox';

function BusinessEnquiryViewModal({ show, headerTitle, bodyData, closeAction, handleClose }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth={'sm'}
                open={show}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    <SoftTypography variant="button" fontWeight="medium">
                        {headerTitle}
                    </SoftTypography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftTypography variant="button" fontWeight="medium">
                                    Name
                                </SoftTypography>
                                <SoftTypography variant="caption" color="secondary">
                                    {bodyData.name}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftTypography variant="button" fontWeight="medium">
                                    Email
                                </SoftTypography>
                                <SoftTypography variant="caption" color="secondary">
                                    {bodyData.email}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftTypography variant="button" fontWeight="medium">
                                    Phone Number
                                </SoftTypography>
                                <SoftTypography variant="caption" color="secondary">
                                    {bodyData.phone_number}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                        {bodyData.company_name && (
                            <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                                <SoftBox display="flex" flexDirection="column">
                                    <SoftTypography variant="button" fontWeight="medium">
                                        Company Name
                                    </SoftTypography>
                                    <SoftTypography variant="caption" color="secondary">
                                        {bodyData.company_name}
                                    </SoftTypography>
                                </SoftBox>
                            </SoftBox>
                        )}
                        {bodyData.job_title && (
                            <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                                <SoftBox display="flex" flexDirection="column">
                                    <SoftTypography variant="button" fontWeight="medium">
                                        Job Title
                                    </SoftTypography>
                                    <SoftTypography variant="caption" color="secondary">
                                        {bodyData.job_title}
                                    </SoftTypography>
                                </SoftBox>
                            </SoftBox>
                        )}
                        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftTypography variant="button" fontWeight="medium">
                                    Category
                                </SoftTypography>
                                <SoftTypography variant="caption" color="secondary">
                                    {bodyData.enquiry_type}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                        {bodyData.source  && (
                            <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                                <SoftBox display="flex" flexDirection="column">
                                    <SoftTypography variant="button" fontWeight="medium">
                                        Source
                                    </SoftTypography>
                                    <SoftTypography variant="caption" color="secondary">
                                        {bodyData.source}
                                    </SoftTypography>
                                </SoftBox>
                            </SoftBox>
                        )}
                        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftTypography variant="button" fontWeight="medium">
                                    Description
                                </SoftTypography>
                                <SoftTypography variant="caption" color="secondary">
                                    {bodyData.description}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <SoftButton variant="gradient" color={closeAction.color} onClick={handleClose}>
                        {closeAction.title}
                    </SoftButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
BusinessEnquiryViewModal.defaultProps = {
    show: false,
    headerTitle: '',
    bodyData: {},
    show: false,
    closeAction: {},
    handleClose: () => { },
};
BusinessEnquiryViewModal.propTypes = {
    show: PropTypes.bool.isRequired,
    headerTitle: PropTypes.string.isRequired,
    bodyData: PropTypes.any.isRequired,
    closeAction: PropTypes.any.isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default BusinessEnquiryViewModal;
